// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"tjenester-module--disclaimer--38RW4","pagecontainer":"tjenester-module--pagecontainer--LdFZo"};